module.exports = __webpack_public_path__ + "e15dd40fc530c29fe335597396742be5.svg";